import React from 'react';
import { motion } from 'framer-motion';
import { ICONS } from '../../data/programs';
import '../../styles/components/landing/BenefitsSection.css';

const BenefitsSection = ({ eyebrow, title, subtitle, items = [] }) => {
  return (
    <section className="ls-benefits">
      <div className="container">
        <div className="ls-benefits__header">
          {eyebrow && <span className="ls-benefits__eyebrow">{eyebrow}</span>}
          <h2 className="ls-benefits__title">{title}</h2>
          {subtitle && <p className="ls-benefits__subtitle">{subtitle}</p>}
        </div>

        <div className="ls-benefits__grid">
          {items.map((item, i) => {
            const Icon = ICONS[item.icon] || ICONS.Sparkles;
            return (
              <motion.div
                key={i}
                className="ls-benefits__card"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-80px' }}
                transition={{ duration: 0.45, delay: i * 0.08 }}
              >
                <div className="ls-benefits__icon">
                  <Icon size={22} />
                </div>
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
